import type { RxJsonSchema, WithDeleted } from "rxdb";
import { INVOICE_SCHEMA_LITERAL, type Invoice } from "./invoice";

export const RXDB_INVOICE_CONFLICT_CASE_COLLECTION_NAME =
  "invoice-conflict-case";

export type InvoiceConflictCaseSnapshot = WithDeleted<Invoice>;

export type InvoiceConflictCase = {
  id: string;
  invoiceId: string;
  createdByUserId: string;
  detectedAt: string;
  losingLocal: InvoiceConflictCaseSnapshot;
  winner: InvoiceConflictCaseSnapshot;
  assumedMaster: InvoiceConflictCaseSnapshot | null;
};

export const INVOICE_SNAPSHOT_SCHEMA = {
  type: "object",
  properties: INVOICE_SCHEMA_LITERAL.properties,
  required: INVOICE_SCHEMA_LITERAL.required,
} as const;

const NULLABLE_INVOICE_SNAPSHOT_SCHEMA = {
  ...INVOICE_SNAPSHOT_SCHEMA,
  type: ["object", "null"],
} as const;

const INVOICE_CONFLICT_CASE_SCHEMA_LITERAL = {
  title: "invoice conflict case schema",
  version: INVOICE_SCHEMA_LITERAL.version,
  description:
    "A local invoice that lost a replication conflict, with the server document that won and the server version it branched from",
  type: "object",
  primaryKey: "id",
  properties: {
    id: { type: "string", maxLength: 100 },
    invoiceId: { type: "string", maxLength: 100 },
    createdByUserId: { type: "string" },
    detectedAt: { type: "string", format: "date-time" },
    losingLocal: INVOICE_SNAPSHOT_SCHEMA,
    winner: INVOICE_SNAPSHOT_SCHEMA,
    assumedMaster: NULLABLE_INVOICE_SNAPSHOT_SCHEMA,
  },
  required: [
    "id",
    "invoiceId",
    "createdByUserId",
    "detectedAt",
    "losingLocal",
    "winner",
    "assumedMaster",
  ],
  indexes: ["invoiceId"],
  encrypted: ["createdByUserId", "losingLocal", "winner", "assumedMaster"],
} as const;

export const INVOICE_CONFLICT_CASE_SCHEMA: RxJsonSchema<InvoiceConflictCase> =
  INVOICE_CONFLICT_CASE_SCHEMA_LITERAL;
